import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Poplatok} from '../model/poplatok';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-poplatok-item',
  templateUrl: './poplatok-item.component.html',
  styleUrls: ['./poplatok-item.component.css']
})
export class PoplatokItemComponent implements OnInit, OnDestroy {

  @Input() poplatok: Poplatok;

  loading = false;
  platobnaBrana = false;
  downloadSubscription: Subscription;
  infoDataSubscription: Subscription;

  constructor(private appService: AppService, private http: HttpClient) { }

  ngOnInit() {
    this.infoDataSubscription = this.appService.infoData.subscribe(
      (data) => {
        this.platobnaBrana = data.platobnaBrana;
      });
  }

  download(p: Poplatok) {
    this.loading = true;
    this.downloadSubscription = this.appService.predpisDownloaded
      .subscribe(
        (value) => {
          this.loading = false;
          this.downloadSubscription.unsubscribe();
        }
      );
    this.appService.downloadPoplatokPredpis(p.id);
  }

  pay(poplatok: Poplatok) {
    this.loading = true;
    this.http.get<{paymentLink: string}>('/ais/rest/portal/portal/payment/' + poplatok.id).subscribe({
      next: (url) => {
        this.loading = false;
        open(url.paymentLink, 'GPW', 'status=0,title=0,top=200,left=200,height=400,width=652,scrollbars=0');
      },
      error: (error) => {
        this.appService.openErrorDialog(error.error.message);
        this.loading = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.infoDataSubscription.unsubscribe();
  }

}
